<template>
  <div
    class="outlined rounded ma-1"
  >
    <v-chip
      label
      small
      color="inputBg"
      :text-color="textColor"
      :close="closable"
      close-icon="mdi-close mdi-12px"
      @click:close="$emit('click:close')"
      @input="$emit('input', $event)"
    >
      <slot>{{ text }}</slot>
    </v-chip>
  </div>
</template>

<script>
  export default {
    name: 'AppTag',

    props: {
      closable: {
        type: Boolean,
        default: false,
      },
      textColor: {
        type: String,
      },
      text: {
        type: String,
      },
    },
  }
</script>
